<template>
  <div class="h-auto w-full mr-3 mb-3">
    <div class="bg-white mx-3 rounded-b-md">
      <div class="border-b-0.5 flex justify-between items-center p-2">
        <p class="text-sm font-semibold w-full">List of Assets Brands</p>
      </div>
      <div class="flex justify-between items-center p-2">
        <el-pagination
          background
          @size-change="handleSizeChange"
          :page-sizes="pageSizes"
          :page-index="pageIndex"
          :page-size="pageSize"
          layout="sizes"
          :total="currentTableData.length"
        >
        </el-pagination>
        <!-- search -->
        <input
          v-model="searchInput"
          type="search"
          placeholder="Start typing to search..."
          class="bg-gray-200 w-52 py-1 rounded-md"
        />
        <!-- search -->
        <div class="flex flex-wrap justify-end w-full gap-3">
          <div
            @click="showCreateAssetBrand = true"
            class="bg-primary flex gap-1 text-white items-center text-sm px-2 py-1 rounded-md cursor-pointer"
          >
            <svg
              id="Layer_1"
              height="20"
              viewBox="0 0 24 24"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              fill="#fff"
            >
              <path
                d="m12 0a12 12 0 1 0 12 12 12.013 12.013 0 0 0 -12-12zm4 13h-3v3a1 1 0 0 1 -2 0v-3h-3a1 1 0 0 1 0-2h3v-3a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2z"
              />
            </svg>
            <p>Create</p>
          </div>
        </div>
      </div>
      <div class="px-2 pb-2">
        <transition name="fade">
          <div v-if="loading" class="inset-0 absolute z-50 bg-white w-full">
            <loader class="center-h-v" />
          </div>
        </transition>

        <transition name="fade">
          <div
            v-if="del_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="get_error"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ get_error }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="create_success"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ create_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="del_success"
            class="p-1 text-center text-sm w-full bg-green-200"
          >
            {{ del_success }}
          </div>
        </transition>
        <transition name="fade">
          <div
            v-if="del_document"
            class="p-1 text-center text-sm w-full bg-yellow-200"
          >
            {{ del_document }}
          </div>
        </transition>
        <div class="w-full overflow-x-auto">
          <ve-table
            v-if="searchInput"
            :columns="columns"
            :table-data="filteredTableData"
            sort-order="asc"
          />

          <ve-table
            :columns="columns"
            :tableData="currentTableData"
            v-if="!searchInput.length"
          >
          </ve-table>

          <p
            v-if="searchInput.length && filteredTableData.length === 0"
            class="text-center py-3"
          >
            No results
          </p>

          <p
            v-if="tableData.length == 0 && !loading && !get_error"
            class="p-1 text-center text-sm w-full bg-gray-100"
          >
            No assets found
          </p>
          <!-- Pagination -->
          <div class="table-pagination text-center mt-2">
            <!-- <ve-pagination :total="totalCount" :page-index="pageIndex" :page-size="pageSize"
              @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" :show-jumper="false" /> -->
            <el-pagination
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
            >
              <!-- :current-page.sync="currentPage4" -->
            </el-pagination>
          </div>
          <!-- Pagination -->
        </div>
      </div>
    </div>
    <!-- create -->
    <CreateAssetBrand
      @close="showCreateAssetBrand = false"
      @closeOnSuccess="handleCloseOnSuccess"
      :showCreateAssetBrand="showCreateAssetBrand"
      :reload="reload"
    >
    </CreateAssetBrand>

    <!-- edit -->
    <EditAssetBrand
      @close="handleClose"
      :info="assetToEdit"
      :showEditAssetBrand="showEditAssetBrand"
      :reload="reload"
    >
    </EditAssetBrand>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
    <BulkUploadAssets
      :show-asset-bulk-upload="showAssetBulkUpload"
      v-if="showAssetBulkUpload"
      @close="showAssetBulkUpload = false"
      :reload="reload"
    ></BulkUploadAssets>
  </div>
</template>

<script>
import axios from "axios";
import CreateAssetBrand from "./createAssetBrand.vue";
import EditAssetBrand from "@/components/CompanySetups/assetsSetups/assetBrands/editAssetBrand.vue";
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "@/utils/actionWarning.vue";
import BulkUploadAssets from "@/components/employees/modals/bulkUploadAssets.vue";
import { importTemplateGenerator } from "@/utils/importTemplateGenerator";
import { mapGetters } from "vuex";

export default {
  name: "AssetBrandList",
  components: {
    Loader,
    CreateAssetBrand,
    ActionWarning,
    EditAssetBrand,
    BulkUploadAssets,
  },

  data() {
    return {
      showAssetBulkUpload: false,
      showCreateAssetBrand: false,
      showEditAssetBrand: false,
      loading: false,
      get_error: null,
      create_success: null,
      del_document: null,
      del_success: null,
      del_error: null,
      info: null,
      message: null,
      filteredTabs: [],
      title: null,
      searchInput: "",
      showActions: false,
      assetToDelete: null,
      showWarning: false,
      assetToEdit: {},
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      pageSizes: [],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "#",
          width: 3,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },

        {
          field: "Name",
          key: "name",
          title: "Name",
          headerAlign: "left",
          align: "left",
          sampleValue: "Apple",
        },

        {
          field: "Description",
          key: "description",
          title: "Description",
          headerAlign: "left",
          align: "left",
          sampleValue: "Apple Device",
        },

        {
          title: "Action",
          field: "",
          key: "action",
          renderBodyCell: ({ row }) => (
            <ve-popper
              trigger="clickToOpen"
              options={{
                placement: "top",
                modifiers: { offset: { offset: "0,10px" } },
              }}
            >
              <div class="bg-white p-2 shadow-md popper">
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleEditButtonClick(row)}
                >
                  Edit
                </button>
                <button
                  class="w-full text-left py-1 px-2 hover:bg-primary hover:text-white"
                  style="boder-radius: 0 !important"
                  onClick={() => this.handleDeleteButtonClick(row)}
                >
                  Delete
                </button>
              </div>

              <button slot="reference">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="Outline"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                >
                  <circle cx="12" cy="2" r="2" />
                  <circle cx="12" cy="12" r="2" />
                  <circle cx="12" cy="22" r="2" />
                </svg>
              </button>
            </ve-popper>
          ),
        },
      ],

      tableData: [],
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
    filteredTableData() {
      if (!this.searchInput) {
        // If no search input is provided, return the full tableData
        return this.tableData;
      } else {
        // Filter the tableData based on the search input
        const searchInputLower = this.searchInput.toLowerCase();
        return this.tableData.filter((item) => {
          // Loop through each item's properties and check if they contain the search input
          for (let key in item) {
            if (
              item[key]?.toString().toLowerCase().includes(searchInputLower)
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    // table data
    currentTableData() {
      const { pageIndex, pageSize } = this;
      return this.tableData.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    },
    // total count
    totalCount() {
      return this.tableData.length;
    },
  },
  created() {
    this.getAssetTypes();
    this.setPageSizes();
  },
  methods: {
    reload() {
      this.getAssetTypes();
      this.showEditAssetBrand = false;
      this.showCreateAssetBrand = false;
      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },

    handleEditButtonClick(asset) {
      // Handle the button click for the edit button
      //console.log(asset);
      this.assetToEdit = asset;

      this.showEditAssetBrand = true;
    },
    handleSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    handleCurrentChange(currentPage) {
      this.pageIndex = currentPage;
    },
    setPageSizes() {
      // Generate the page sizes array using a loop
      for (let i = 1; i <= 10; i++) {
        this.pageSizes.push(this.pageSize * i);
      }
    },
    // page number change
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    handleDeleteButtonClick(asset) {
      // Handle the button click for the delete button
      //console.log(asset)
      this.title = `Delete ${asset.Name}`;
      this.message = `You are about to delete ${asset.Name} from the assets type list!`;
      this.assetToDelete = asset;
      //console.log(this.assetToDelete)
      this.showWarning = true;
    },
    setIsConfirmed() {
      this.showWarning = false;
      if (this.assetToDelete) {
        this.deleteAsset(this.assetToDelete);
        return;
      }
    },

    exportTemplate() {
      this.filteredTabs = this.columns.filter(
        (column) => column.title !== "Action"
      );
      importTemplateGenerator(this.filteredTabs, "Assets Brands");
    },
    handleClose() {
      this.showCreateAssetBrand = false;
      this.showEditAssetBrand = false;
    },
    handleCloseOnSuccess() {
      this.showCreateAssetBrand = false;
      this.showLocCrSuccess = true;
      setTimeout(() => {
        this.showLocCrSuccess = false;
      }, 3000);
      this.getAssetTypes();
    },

    handleDeleteOnSuccess() {
      setTimeout(() => {
        this.del_success = null;
      }, 3000);
      this.getAssetTypes();
    },

    Adddocument(row) {
      this.selectedRow = row;
      this.showAdddocument = true;
    },

    handleCloseOnAddDept() {
      this.showAdddocument = false;
      this.showAdddocumentSuccess = true;
      setTimeout(() => {
        this.showAdddocumentSuccess = false;
      }, 3000);
    },

    // /{organization}/asset/status/v1/request
    getAssetTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/asset/brand/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/asset/{assetId}/v1/delete
    deleteAsset(row) {
      //console.log(row)
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
        data: {
          Id: row.Id,
        },
      };
      axios
        .delete(`${this.getOrganization}/asset/brand/v1/delete`, options)
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.del_success = response.data.StatusMessage;
              this.handleDeleteOnSuccess();
              // this.getAssetTypes()
            } else {
              this.del_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.del_error = error.message;
          }
        );
    },
  },
};
</script>
<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
